import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PartnersService } from '../../../core/routing/services/Partners_api/partners.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Partners, CreatePartner, UpdatePartner } from '../Partners/Interface/partner.i';
import { OemService } from '../../../core/routing/services/oem/oem.service';
import { Content } from '../../oem-portal/interface/oem-portal-interface.i';
import { AttractLoopVideo } from '../../oem-portal/interface/oem-portal-interface.i';
import { OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { PartnerContentStore } from '../store/partner-content-store';


@Component({
  selector: 'iposcen-approved-partner-content',
  templateUrl: './approved-partner-content.component.html',
  styleUrls: ['./approved-partner-content.component.scss']
})
export class ApprovedPartnerContentComponent implements OnInit {
  @Output() readonly viewOn = new EventEmitter();
  @Output() readonly contentID = new EventEmitter();
  @Output() readonly autoID = new EventEmitter();
  @Output() readonly attrViewOpen = new EventEmitter();
  @Output() readonly attrID = new EventEmitter();
  @Output() readonly adminRef = new EventEmitter();
  @Output() readonly pid = new EventEmitter();
  @Input() selectedPartnerName: string;
  @Input() checkReviewStatus: boolean;
  @Input() checkViewStatus: boolean;
  @Input() contentsInfo: any;
  @Input() isPartnerTabActive: boolean;
  videoInfo: any;
  page: number;
  pageAttr: number
  tableSize: number;
  showFrom: number;
  showTo: number;
  maxSize = 5;
  paginationCount: number;
  selectedButton: string;
  close: boolean;
  isViewOpen: boolean;
  partner: Partners[];
  partnerData: any;
  isNoneSelected: boolean;
  contents: Content[];
  attractLoop: AttractLoopVideo[];
  globalSortBy: string;
  globalSortValue: string;
  pID: any;
  spinnerStatus = true;
  partnerLabel: string;
  private ngUnsubscribe = new Subject<boolean>();
  noData: boolean;
  partnerID: any;
  isPartnerEmpty: boolean;
  noAttractLoop: boolean;
  showFromAttr: number;
  showToAttr: number;
  attractViewOn: boolean;
  openModal = false;
  openConfirmationAttractPopup = false;
  openConfirmationContentPopup = false;
  contentsName: any;
  contentsID: any;
  attractLoopName: any;
  attractLoopId: any;
  doneState = false;
  devicesCount: number;
  constructor(private partnersService: PartnersService, private oemService: OemService, private store: PartnerContentStore) { }

  ngOnInit(): void {
    this.page = 1;
    this.pageAttr = 1;
    this.tableSize = 10;
    this.showFrom = 0;
    this.showTo = 0;
    this.paginationCount = 0;
    this.isPartnerTabActive = true;
    this.selectedButton = this.checkReviewStatus || this.checkViewStatus ? this.selectedPartnerName : OemConstants.SELECT_PARTNER;
    this.isNoneSelected = true;
    this.isViewOpen = false;
    this.attractViewOn = false;
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.noData = false;
    this.noAttractLoop = false;
    this.getApprovedPartnerData();
    this.back();
  }

  back() {
    if (this.checkReviewStatus || this.checkViewStatus) {
      if (this.checkReviewStatus) {
        this.contents = this.contentsInfo.contents;
        this.pID = this.contentsInfo.partnerID[0];
        this.paginationCount = this.contentsInfo.paginationContext.totalItems;
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
      } else {
        this.isPartnerTabActive = false;
        this.store.getAttrLoop.subscribe(res => {
          this.attractLoop = res;
          this.pID = this.attractLoop[0].partnerID;
          this.showFromAttr = ((this.pageAttr - 1) * this.tableSize) + 1;
          this.showToAttr = Math.min(this.pageAttr * this.tableSize, this.attractLoop?.length);
        })
      }
    }
  }

  // IIT2-32 chnages for push updates modal
  openConfirmationContentGroupPopup (contentName, contentID) {
    this.openConfirmationContentPopup = !this.openConfirmationContentPopup;
    this.contentsName = contentName;
    this.contentsID = contentID;
    this.attractLoopName = false;
  }

  openConfirmationAttractPopupModal(attractLoopName, attractLoopId) {
    this.openConfirmationAttractPopup = !this.openConfirmationAttractPopup;
    this.attractLoopName = attractLoopName;
    this.attractLoopId = attractLoopId;
    this.contentsName = false;
  }


  openPushUpdatesModal(contentName) {
    this.openModal = !this.openModal;
    this.openConfirmationContentPopup = false;
    this.openConfirmationAttractPopup = false;
    this.contentsName = contentName;
    this.attractLoopName = false;
    const payload =  {"oemContent":[{
      oemContentId: this.contentsID,
      oemContentName: this.contentsName,
      showOnDevice: true
    }]}
    this.partnersService.sendApproveAndPush(payload, true)
      .pipe()
      .subscribe(response => {
        this.doneState = true;
        this.devicesCount = response.deviceCount;
      },
      error => { // do something
      });
  }
  openPushAttractModal(attractLoopName) {
    this.openModal = !this.openModal;
    this.openConfirmationContentPopup = false;
    this.openConfirmationAttractPopup = false;
    this.attractLoopName = attractLoopName;
    this.contentsName = false;
    const payload = {"oemAttractloops":[{
      oemAttractloopId: this.attractLoopId,
      oemAttractloopName: this.attractLoopName,
      showOnDevice: true
    }]};
    this.partnersService.sendApproveAndPush(payload, true)
      .pipe()
      .subscribe(response => {
        this.devicesCount = response.deviceCount;
        this.doneState = true;
      },
      error => { // do something
      });
  }
  closeModal() {
    this.openModal = false;
    this.openConfirmationContentPopup = false;
    this.openConfirmationAttractPopup = false;
  }

  getApprovedPartnerData() {
    this.partnersService.getApprovedPartners(OemConstants.APPROVED_STATUS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllPartnerResponse => {
        this.partner = getAllPartnerResponse.partnerName;
        this.partnerID = getAllPartnerResponse.partnerID;
        this.isPartnerEmpty = (this.partner.length == 0) || false;
        let temp = new Map()
        this.partner.forEach((e, i) => {
          temp.set(e, this.partnerID[i])
        })
        this.partnerData = new Map([...temp.entries()].sort());
        this.partner = Array.from(this.partnerData.keys());
        this.partnerID = Array.from(this.partnerData.values());
      });
  }

  selectedPartner(data, pID) {
    this.partnerLabel = data;
    this.pID = pID;
    this.selectedButton = data;
    this.page = 1;
    this.pageAttr = 1;
    this.getContentData(pID, OemConstants.APPROVED_STATUS);
    this.getAllAttractLoopVideos(pID);
  }

  getContentData(pID, status) {
    this.oemService.getContentDataUsingPartnerID(this.globalSortBy, this.globalSortValue, this.page, pID, status)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getApprovedPartnerResponse => {
       this.contents = getApprovedPartnerResponse.contents as Content[];
        this.paginationCount = (getApprovedPartnerResponse.paginationContext.totalItems);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.contents.length === 0) {
          this.isPartnerTabActive = false;
          this.showFrom = 0;
          this.showTo = 0;
          this.noData = true;
        } else {
          this.isPartnerTabActive = true;
          this.noData = false;
        }

      });
  }

  getAllAttractLoopVideos(data) {
    this.oemService.getApprovedAttractLoopVideoBypID(this.globalSortBy, this.globalSortValue, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllPartnerResponse => {
        this.attractLoop = getAllPartnerResponse.attractLoops.map(data => {
           if (data.locations) {
            try {
              data.parsedLocations = JSON.parse(data.locations);
            } catch {
              data.parsedLocations = [];
            }
          }
          return data;
        });
        if (this.attractLoop?.length === 0) {
          this.noAttractLoop = true;
          this.showFromAttr = 0;
          this.showToAttr = 0;
        } else {
          this.noAttractLoop = false;
          this.showFromAttr = ((this.pageAttr - 1) * this.tableSize) + 1;
          if (this.attractLoop?.length < 10) {
            this.showToAttr = this.attractLoop?.length;
          } else {
            this.showToAttr = this.pageAttr * this.tableSize;
          }
        }
      });
  }
  sort(sortKey: string) {
    if (this.isPartnerTabActive) {
      switch (sortKey) {
        case (OemConstants.CONTENT_NAME):
          this.sortingTableWithAscandDesc(OemConstants.CONTENT_NAME);
          break;
        case (OemConstants.LANG_CAT):
          this.sortingTableWithAscandDesc(OemConstants.LANG_CAT);
          break;
        case (OemConstants.SYSTEM_ID_DISPLAY):
          this.sortingTableWithAscandDesc(OemConstants.SYSTEM_ID_DISPLAY);
          break;
        case (OemConstants.CREATED_BY_NAME):
          this.sortingTableWithAscandDesc(OemConstants.CREATED_BY_NAME);
          break;
        case (OemConstants.UPDATED_TIME):
          this.sortingTableWithAscandDesc(OemConstants.UPDATED_TIME);
          break;
        default: {
        }
      }
    } else {
      switch (sortKey) {
        case (OemConstants.ATTRACT_LOOPNAME):
          this.sortingTableWithAscandDesc(OemConstants.ATTRACT_LOOPNAME);
          break;
        case (OemConstants.UPDATED_TIME):
          this.sortingTableWithAscandDesc(OemConstants.UPDATED_TIME);
          break;
        case (OemConstants.UPDATED_BYNAME):
          this.sortingTableWithAscandDesc(OemConstants.UPDATED_BYNAME);
          break;
        default: {
        }
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    this.globalSortValue = this.globalSortValue !== OemConstants.ASCENDING_ORDER ? OemConstants.ASCENDING_ORDER :
      OemConstants.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    if (this.isPartnerTabActive) {
      this.getContentData(this.pID, OemConstants.APPROVED_STATUS);
    } else {
      this.getAllAttractLoopVideos(this.pID)
    }
  }

  openView(contentID, autoID) {
    this.viewOn.emit(true);
    this.isViewOpen = true;
    this.contentID.emit(contentID);
    this.autoID.emit(autoID);
  }

  openAttrView(attrID) {
    this.attractViewOn = true;
    this.attrID.emit(attrID);
    this.attrViewOpen.emit(true);
    this.adminRef.emit(true);
    this.pid.emit(this.pID)
    
  }

  onTableDataChange(event) {

    if (this.isPartnerTabActive) {
      this.page = event;
      this.getContentData(this.pID, OemConstants.APPROVED_STATUS);
    } else {
      this.pageAttr = event;
      this.getAllAttractLoopVideos(this.pID);
    }
  }

  tabChange() {
    this.isPartnerTabActive = !this.isPartnerTabActive;
  }
}
